import { useContext, useEffect } from "react";
import { DataContext } from "../../context/Data.context";
import { Separator } from "@moreirapontocom/npmhelpers";
import { Link } from "react-router-dom";

import "./About.scss";

const About = () => {
  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "About",
        backButton: false,
      },
      hideNavbar: true,
    });
  }, []);

  return <>
    <div className="About">
      <div className="text-center">
        <img src="/images/about.png" alt="aptitude" className="img-fluid" style={{ width: "350px" }} />

        <Separator size={40} />

        <h1>
          <strong>Metrix</strong>
        </h1>
        Version 1.0

        <Separator size={40} />

        <div className="row justify-content-center">
          <div className="col-3">

            <div className="d-grid">
              <Link className="btn btn-outline-secondary" to="/home">
                OK
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  </>
};

export default About;